import 'owl.carousel';
import './prototypes';
import './functions';
import './scroll';
import './before-load';
import './hero-animation';
import './menu';
import './tabs';
import './components/marquee';
import './components/count-up';
import './components/contact-form';
import './components/contact-form-ajax';
import ScrollReveal from 'scrollreveal'

let nav = document.querySelector('ul.nav');
function navBeforeStyle(anchor) {
    if (anchor) {
        nav.style.setProperty('--bp', anchor.offsetLeft + 'px');
        nav.style.setProperty('--bw', anchor.offsetWidth + 'px');
    } else {
        nav.style.setProperty('--bp', 0 + 'px');
        nav.style.setProperty('--bw', 0 + 'px');
    }
}

let subnavs = document.querySelectorAll('ul.nav>li>ul');
if (subnavs) {
    subnavs.forEach(subnav => {
        let l = 0;
        for (let u = 0; u < subnav.children.length; u++) {
            if (!subnav.children[u].classList.contains('mobile-only')) {
                l++;
            }
        }
        if (l >= 3) {
            l = 3;
            subnav.classList.add('sup3')
        }
        if (l < 1) {
            l = 1;
        }
        subnav.style.setProperty('--sw', l);
    })
}
function tabEntreprise() {
    let tabButtons = document.querySelector('.entreprise_page .entreprise_client .tab-buttons-scroll');
    if (tabButtons) {
        tabButtons.style.maxWidth = (innerWidth - 30) + 'px';
    }
    // if (innerWidth < 768) {
    //     $('.entreprise_page .entreprise_client .tab-buttons').addClass('owl-carousel')
    //     $('.entreprise_page .entreprise_client .tab-buttons').owlCarousel({
    //         autoWidth: true,
    //         nav: false,
    //         dots: false,
    //     });
    // } else {
    //     $('.entreprise_page .entreprise_client .tab-buttons').removeClass('owl-carousel')
    //     $('.entreprise_page .entreprise_client .tab-buttons').trigger('destroy.owl.carousel')
    // }
}

let career_page_steps = document.querySelector('.career_page .section-steps .step-fixed');

function rz() {
    if (career_page_steps) {
        // career_page_steps.parentElement.style.height = "";
        // let steps = career_page_steps.querySelector('.steps');
        // steps.style.height = '';
        // if (innerWidth > 991) {
        //     career_page_steps.parentElement.style.height = (innerHeight * steps.children.length) + "px";
        //     if (steps) {
        //         let offsetheight = 0;
        //         for (let i = 0; i < steps.children.length; i++) {
        //             let step = steps.children[i];
        //             if (step) {
        //                 if (offsetheight < step.offsetHeight) {
        //                     offsetheight = step.offsetHeight;
        //                 }
        //             }
        //         }
        //         steps.style.height = (offsetheight + 30) + 'px';
        //         career_page_steps.childHeight = (offsetheight + 30);
        //     }
        //     window.stepscroll(career_page_steps)
        // }
    }
    let shapeanms = document.querySelectorAll('.shape-anm');
    if (shapeanms) {
        let x = Math.round(innerWidth / 713);
        let xn = Math.round(innerWidth / 540);
        shapeanms.forEach(ell => {
            ell.style.setProperty('--wd', x + 1)
            ell.style.setProperty('--wd-n', xn + 1)
            // ell.style.setProperty('--wd-n-2', x - 2)
        })
    }

    let navchildren = document.querySelectorAll('ul.nav > li > ul > li.menu-item-has-children > ul > li.menu-item-has-children');
    if (navchildren && navchildren.length) {
        if (innerWidth > 991) {
            let m = Math.round(navchildren.length / 2);
            let h1 = 0;
            let h2 = 0;
            navchildren.forEach((child, index) => {
                if (m < index) {
                    h1 += child.offsetHeight;
                } else {
                    h2 += child.offsetHeight;
                }
            })
            let h = h1 > h2 ? h1 : h2;
            navchildren[0].parentElement.style.maxHeight = h + "px";
        } else {
            navchildren[0].parentElement.style.maxHeight = "";
        }
    }

}
addEventListener('load', function () {
    window.inScroll();
    window.scrollShape();
    tabEntreprise();
    rz();
    scrollTest();
    setTimeout(() => {
        let mainnav = document.querySelector('.main-nav');
        if (mainnav) {
            mainnav.classList.add('events')
        }
    }, 500)

    $('.owl-carousel.cards').owlCarousel({
        autoWidth: true,
        margin: 35,
        nav: false,
        dots: false,
        items: 1,
        responsive: {
            0: {
                autoWidth: true,
                items: 1,
            },
            768: {
                autoWidth: true,
                items: 1,
            },
        },
    });
    $('.owl-carousel.list_card_news').owlCarousel({
        margin: 30,
        nav: false,
        dots: false,
        items: 1.2,
        responsive: {
            575: {
                items: 2.2,
                margin: 30,
            },
            768: {
                items: 3,
            },
            992: {
                margin: 64,
                items: 3,
            },
        },
    });

    $('.owl-carousel.steps-carousel').owlCarousel({
        autoWidth: false,
        margin: 35,
        nav: false,
        dots: false,
        items: 1,
        responsive: {
            0: {
                items: 1,
            },
            992: {
                items: 1,
            },
        },
    });

    let teamsCarousel = $('.owl-carousel.team-carousel');
    teamsCarousel.owlCarousel({
        autoWidth: true,
        margin: 32,
        nav: false,
        dots: false,
        items: 2,
    });
    $('.owl-carousel.carousel-images').owlCarousel({
        autoWidth: true,
        margin: 35,
        nav: false,
        dots: false,
        center: true,
    });
    $('.owl-carousel.list_news').owlCarousel({
        nav: false,
        dots: false,
        responsive: {
            0: {
                margin: 20,
                loop: false,
                items: 1,
                autoWidth: true,
            },
            768: {
                items: 2,
                margin: 20,
                autoWidth: true,
            },
            992: {
                items: 3,
                margin: 55,
            },
        },
    });


    $('.owl-carousel.carousel-images .carousel-image').on('mouseover', function () {
        setTimeout(() => {
            $('.owl-carousel.carousel-images').trigger('refresh.owl.carousel')

        }, 50)
    })
    if (nav) {
        window.anchor_active = document.querySelector('ul.nav .nav>li.current-menu-item>a');
        window.anchor_Lastactive = window.anchor_active;
        navBeforeStyle(window.anchor_active)
        let anchors = document.querySelectorAll('ul.nav>li');
        if (anchors) {
            anchors.forEach(anchor => {
                anchor.addEventListener('mouseover', function () {
                    if (nav.timeout) {
                        clearTimeout(nav.timeout);
                    }
                    navBeforeStyle(this.children[0]);
                    if (anchor.children.length > 1) {
                        document.body.classList.add('body-hover-nav')
                    }
                    nav.timeoutTransition = setTimeout(() => {
                        nav.classList.add('scroll-y')
                    }, 700)
                    let navchildren = document.querySelectorAll('ul.nav > li > ul > li.menu-item-has-children > ul > li.menu-item-has-children');
                    if (navchildren && navchildren.length) {
                        if (innerWidth > 991) {
                            let m = Math.round(navchildren.length / 2);
                            let h1 = 0;
                            let h2 = 0;
                            navchildren.forEach((child, index) => {
                                if (m < index) {
                                    h1 += child.offsetHeight;
                                } else {
                                    h2 += child.offsetHeight;
                                }
                            })
                            let h = h1 > h2 ? h1 : h2;
                            navchildren[0].parentElement.style.maxHeight = h + "px";
                        } else {
                            navchildren[0].parentElement.style.maxHeight = "";
                        }
                    }
                })
                anchor.addEventListener('mouseleave', function () {
                    nav.timeout = setTimeout(() => {
                        navBeforeStyle(window.anchor_active)
                    }, 100)
                    if (nav.timeoutTransition) {
                        clearTimeout(nav.timeoutTransition);
                    }
                    nav.classList.remove('scroll-y')
                    document.body.classList.remove('body-hover-nav')

                })
            })

        }
    }
    $('.link_error_back').on('click', () => {
        history.go(-1);
        window.scrollTo(0, 0);
    })


})
let clippathshapes = document.querySelector('.clip-path-shapes');
function aclippathshapes() {
    if (clippathshapes) {
        document.body.style.setProperty('--shape-scale', (innerWidth - 32) / 767)
    }
}
aclippathshapes();

addEventListener('resize', function () {
    // document.body.classList.remove('body-button-nav');
    addDynamicMarginBottom();
    aclippathshapes();
    tabEntreprise();
    rz();
    existAnnouncement();
})



addEventListener('scroll', function () {
    window.inScroll();
    // window.stepscroll(career_page_steps)
    window.scrollShape();
    window.scrollButtonTab();
    let share_container = document.querySelector('.shares-container');
    if (share_container) {
        let share_scroll = share_container.querySelector('.shares-content');
        if (share_scroll && innerWidth > 992) {
            let rect_share_scroll = share_container.getBoundingClientRect();
            if (rect_share_scroll.top + share_container.offsetHeight < 140) {
                share_scroll.classList.add('absolute')
            } else {
                share_scroll.classList.remove('absolute')
                if (rect_share_scroll.top < 92) {
                    share_scroll.classList.add('fixed')
                } else {
                    share_scroll.classList.remove('fixed')
                }
            }
        }
    }
    if (scrollY > 10) {
        document.body.classList.add('body-scroll-10')
    } else {
        document.body.classList.remove('body-scroll-10')
    }
    return true;
})

// Simple menu
let navWithChild = document.querySelectorAll('.simple-menu ul.nav .menu-item-has-children > a');
let navFirstChilds = document.querySelectorAll('.simple-menu ul.nav > .menu-item-has-children > a');
let buttonbacknav = document.querySelector('ul.nav > li > .button-back-nav');


if (buttonbacknav) {
  buttonbacknav.addEventListener('click', function () {
    if (buttonbacknav.ee) {
      buttonbacknav.ee.parentElement.parentElement.callback();
    }
    if (buttonbacknav.me) {
      buttonbacknav.me.parentElement.parentElement.callback();
    }
  });
}
navWithChild.forEach(elem => {
  elem.addEventListener("click", (e) => {
    if (innerWidth < 992) {
      let navFirstChild = false;
      navFirstChilds.forEach(ep => {
        if (ep == elem) {
          navFirstChild = true;
        }
      })
      e.preventDefault();
      let u = elem.parentElement.parentElement;
      if (u.callback && u.el != elem) {
        u.callback();
      }
      if (navFirstChild) {
        elem.parentElement.classList.add("open");
        elem.timeout = setTimeout(() => {
          elem.parentElement.classList.add("show");
        }, 10)
        buttonbacknav.ee = elem;
        buttonbacknav.classList.add('visible');
        if (elem.parentElement.previousElementSibling.previousElementSibling) {
          elem.parentElement.previousElementSibling.style.display = "none"
        }
      } else {
        elem.parentElement.classList.toggle("open");
      }
      u.callback = function () {
        if (navFirstChild) {
          elem.parentElement.classList.remove("show");
          elem.timeout = setTimeout(() => {
            elem.parentElement.classList.remove("open");
          }, 300)
          elem.parentElement.previousElementSibling.style.display = ""
          buttonbacknav.ee = null;
          buttonbacknav.classList.remove('visible');
        } else {
          elem.parentElement.classList.remove("open");
        }
      }
      u.el = elem;

    }
  });
});


// Mega menu
let megaNavWithChild = document.querySelectorAll('.mega-menu ul.nav .nav-mobile .menu-item-has-children > a');
let megaNavFirstChilds = document.querySelectorAll('.mega-menu ul.nav  .nav-mobile > .menu-item-has-children > a');
megaNavWithChild.forEach(elem => {
  elem.addEventListener("click", (e) => {
    if (innerWidth < 992) {
      let navFirstChild = false;
      megaNavFirstChilds.forEach(ep => {
        if (ep == elem) {
          navFirstChild = true;
        }
      })
      e.preventDefault();
      let u = elem.parentElement.parentElement;
      if (u.callback && u.el != elem) {
        u.callback();
      }
      if (navFirstChild) {
        elem.parentElement.classList.add("open");
        elem.timeout = setTimeout(() => {
          elem.parentElement.classList.add("show");
        }, 10)
        buttonbacknav.ee = elem;
        buttonbacknav.classList.add('visible');
        $('ul.nav  .nav-mobile > .menu-item:not(.open)').css('display','none')
        elem.parentElement.parentElement.parentElement.classList.add('is-open');
        /* if (elem.parentElement.previousElementSibling.previousElementSibling) {
            // elem.parentElement.previousElementSibling.style.display = "none"
        } */
      } else {
        elem.parentElement.classList.toggle("open");
      }
      u.callback = function () {
        if (navFirstChild) {
          elem.parentElement.classList.remove("show");
          elem.timeout = setTimeout(() => {
            elem.parentElement.classList.remove("open");
          }, 300)
          $('ul.nav  .nav-mobile > .menu-item').css('display','')
          elem.parentElement.parentElement.parentElement.classList.remove('is-open');

          // elem.parentElement.previousElementSibling.style.display = ""
          buttonbacknav.ee = null;
          buttonbacknav.classList.remove('visible');
        } else {
          elem.parentElement.classList.remove("open");
        }
      }
      u.el = elem;

    }
  });
});





let sectionTabs = document.querySelector('.js-anim-reveal');
let servicestabs = document.querySelector('.tab-services .card-one-item-left');

function scrollTest() {
    if (sectionTabs) {
        let anim = {
            reset: true,
            distance: '100px',
            duration: 1000,
            delay: 800,
        };

        ScrollReveal().reveal('.js-anim-reveal', anim);
    }
    if (servicestabs) {
        let anim = {
            reset: true,
            distance: '100px',
            duration: 1000,
            delay: 0,
        };

        ScrollReveal().reveal('.tab-services .card-one-item-left', anim);
    }
}
/* scrollReveal(); */

let page = 1;
function searchPostClick(element) {
    $('#ajax_result').html('');
    page = 1;
    $('.more').removeClass('show')
    $('#ajax_result').parent().addClass('loading')
    $('.searchPost').removeClass('active');
    $(element).addClass('active');
    let btn_url = $(element).attr('href');
    $.ajax({
        url: btn_url,
        type: 'get',
        success: function (data) {
            $('#ajax_result').parent().removeClass('loading')
            $('#ajax_result').html(data.data);
            page = data.next;
            if (page) {
                $('.more').addClass('show')
            }
            jsBlockLinks();
        },
    });
}

// JS Block link
function jsBlockLinks() {
    // JS block link
    $('.js-block-link').on('click', '.js-link-href', (e) => {
        e.stopPropagation();
    });

    $('.js-block-link').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        let $link = $(e.currentTarget).find('a.js-link-href');

        if($link.length > 0) {
            $link[0].click();
        }
    });
}

// Dynamic margin bottom
function addDynamicMarginBottom() {
    //    console.log( window.innerWidth );
    var headerBannerElementHeight = 0;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
    var headerBannerElement = $('header.has-announcement .header-announcement-bar');

    //
    if( headerBannerElement && windowWidth < 991) {
        headerBannerElementHeight = headerBannerElement.outerHeight();
    }

    // Update padding bottom on body
    $('body').css('padding-bottom', headerBannerElementHeight+'px');
}

// Manage header announcement bar close btn
function manageAnnouncementBar() {
    // Get cookie value
    var cookieValue = window.getCookie('lg-hide-header-announcement');

    if( !cookieValue ) {
        // if cookie is not set then make it visible
        $('header.main-header').addClass('has-announcement');
        $('body').addClass('bhas-announcement');

        // bind click event
        $('header.has-announcement .header-announcement-bar__close').on('click', () => {
            // set cookie for 3 days
            window.setCookie('lg-hide-header-announcement', true, 3);
            var megaMenu = $('.main-header.has-announcement .header-fixed .header-color .header-container .header-row ul.nav > li > ul');
            var hasAnnouncement = $('.main-header');
            // then remove class to hide the announcement bar
            $('header.has-announcement').removeClass('has-announcement');
            $(megaMenu).css('margin-top', '0px');
            $(hasAnnouncement).css('margin-bottom', '0px');
            //
            $('body').css('padding-bottom', '0px');
        })
    }
}

// Manage exist or not has-announcement
function existAnnouncement() {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        var hasAnnouncement = $('header.has-announcement');
        var hasAnnouncementBar = $('.header-fixed .header-announcement-bar').length;
        var megaMenu = $('.main-header.has-announcement .header-fixed .header-color .header-container .header-row ul.nav > li > ul');
        if( hasAnnouncementBar && windowWidth > 991){
            $(hasAnnouncement).css('margin-bottom', '43px');
            $(megaMenu).css('margin-top', '50px');
        }else{
            $(hasAnnouncement).css('margin-bottom', '0px');
            $(megaMenu).css('margin-top', '0px');
        }
}

$(document).ready(function () {
    /* begin search posts */
    let url = $('input#ajax_load_posts_url').val();
    if (typeof url != "undefined") {
        let xsearchPost = document.querySelector('.searchPost[data-selected="' + location.hash.slice(1) + '"]');
        let per_page = $('input#per_page').val();
        let post_type = $('input#post_type').val();
        let en_vedette = $('input#en_vedette').val();
        if (xsearchPost) {
            searchPostClick(xsearchPost)
        } else {
            $.ajax({
                url: url,
                type: 'get',
                data: { action:( post_type ? post_type : 'load_posts'), total: per_page, en_vedette: en_vedette },
                success: function (data) {
                    $('#ajax_result').parent().removeClass('loading');
                    $('#ajax_result').html(data.data);
                    page = data.next;
                    if (page) {
                        $('.more').addClass('show')
                    }

                    jsBlockLinks();
                },
            });
        }
        $('.searchPost').click(function (e) {
            e.preventDefault();
            searchPostClick(this);
        });

        $('.more').click(function (e) {
            e.preventDefault();
            $('.more').removeClass('show')
            $('#ajax_result').parent().addClass('loading')
            let btn_url = $('.searchPost.active').attr('href');
            $.ajax({
                url: btn_url,
                type: 'get',
                data: { page: page, en_vedette_hide: true },
                success: function (data) {
                    $('#ajax_result').parent().removeClass('loading')
                    $('#ajax_result').append(data.data);
                    page = data.next;
                    if (page) {
                        $('.more').addClass('show')
                    }

                    jsBlockLinks();
                },
            });
        });
    }
    /* end search posts */


    /* begin contact form */
    if ($('body').hasClass("page-template-template-contact")) {
        $(".contact-form").submit(function (e) {
            e.preventDefault();
            let form = $(this);
            let id = $(this).attr('data-id');
            let formData = new FormData($(this)[0]);
            let actionUrl = form.attr('action');
            let method = form.attr('method');
            form.addClass('loading')
            $.ajax({
                type: method,
                url: actionUrl,
                data: formData,
                contentType: false,
                processData: false,
                success: function (data) {
                    form.removeClass('loading')
                    let result = JSON.parse(data);
                    if (result.success) {
                        form.hide();
                        $("#confirmation_" + id).show();
                    } else {
                        $("#confirmation_" + id).html("<p>" + result.message + "</p>");
                        $("#confirmation_" + id).show();
                        let tab_scroll = document.querySelector("#confirmation_" + id).getBoundingClientRect();
                        let y = tab_scroll.top + scrollY - 147;
                        $("html, body").animate({ scrollTop: y });
                    }
                },
            });


        });
    }
    /* end contact form */

    $("#form-search").submit(function (e) {
        e.preventDefault();
        let form = $(this);
        let actionUrl = form.attr('action');
        form.addClass('is-open');
        form.addClass('loading');
        $.ajax({
            type: "GET",
            url: actionUrl,
            data: form.serialize(),
            contentType: false,
            processData: false,
            success: function (data) {
                let result = JSON.parse(data);
                form.removeClass('loading');
                if (result.success === true) {
                    $("#form-search #no-result").hide();
                    $("#form-search #search-result .count").show();
                    $("#form-search #search-result .count .nb").html(result.count);
                    $("#form-search #search-result .count .value").html(result.value);
                    $("#form-search #search-result .results-wrapper").html(result.content);
                    $("#form-search #search-result").show();
                } else {
                    $("#form-search #no-result").show();
                    $("#form-search #search-result .count").hide();
                    $("#form-search #search-result .results-wrapper").html("");
                    $("#form-search #search-result").hide();
                }
            },
        });
    });

    if ($('body').hasClass('single-post')) {

        let isPlaying = false;
        let stop = $('.stop');
        let play = $('.play');
        let audio = document.getElementById("audio");
        $('.audio-content').click(function (e) {
            e.preventDefault();
            if (isPlaying) {
                isPlaying = false;
                toggleButton(stop, play);
                audio.pause();
            } else {
                isPlaying = true;
                toggleButton(play, stop);
                audio.play();
            }
        })

        /* Share Post Mobile */
        let shareBtn = $('.shares-content');
        shareBtn.on('click', function () {
            shareBtn.toggleClass('is-active');
        })
    }

    function toggleButton(current, next) {
        next.addClass('is-active');
        current.removeClass('is-active');
    }


    var popupCenter = function (url, title, width, height) {
        var popupWidth = width || 640;
        var popupHeight = height || 320;
        var windowLeft = window.screenLeft || window.screenX;
        var windowTop = window.screenTop || window.screenY;
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        var popupLeft = windowLeft + windowWidth / 2 - popupWidth / 2;
        var popupTop = windowTop + windowHeight / 2 - popupHeight / 2;
        var popup = window.open(url, title, 'scrollbars=yes, width=' + popupWidth + ', height=' + popupHeight + ', top=' + popupTop + ', left=' + popupLeft);
        popup.focus();
        return true;
    };
    var pageUrl = encodeURIComponent(jQuery("meta[property='og:url']").attr("content"));
    var description = encodeURIComponent(jQuery("meta[property='og:description']").attr("content"));
    var title = encodeURIComponent(jQuery("meta[property='og:title']").attr("content"));
    //var site_name = encodeURIComponent(jQuery("meta[property='og:site_name']").attr("content"));
    var image = encodeURIComponent(jQuery("meta[property='og:image']").attr("content"));
    /*var image_width = encodeURIComponent(jQuery("meta[property='og:image:width']").attr("content"));
    var image_height = encodeURIComponent(jQuery("meta[property='og:image:height']").attr("content"));*/
    let share_twitter = document.querySelector('.share_twitter');
    if (share_twitter) {
        share_twitter.addEventListener('click', function (e) {
            e.preventDefault();
            var shareUrl = "https://twitter.com/intent/tweet?text=" + title +
                "&url=" + pageUrl;
            popupCenter(shareUrl, "Partager sur Twitter");
        });
    }
    let share_facebook = document.querySelector('.share_facebook');
    if (share_facebook) {
        share_facebook.addEventListener('click', function (e) {
            e.preventDefault();
            var shareUrl = "https://www.facebook.com/sharer/sharer.php?u=" + pageUrl +
                "&summary=" + description +
                "&[images][0]=" + image;
            popupCenter(shareUrl, "Partager sur facebook");
        });
    }
    let share_linkedin = document.querySelector('.share_linkedin');
    if (share_linkedin) {
        share_linkedin.addEventListener('click', function (e) {
            e.preventDefault();
            var shareUrl = "https://www.linkedin.com/shareArticle?url=" + pageUrl;
            popupCenter(shareUrl, "Partager sur Linkedin");
        });
    }

    jsBlockLinks();

    /* manage announcement bar */
    manageAnnouncementBar();

    /* add padding based on header banner on mobile devices */
    addDynamicMarginBottom();

    /* Check exist Annonce */
    existAnnouncement();

});



// WEBPACK FOOTER //
// ./scripts/main.js